import {
  CONFIRM_FILES_UPLOAD_TEST_ID,
  FILE_MANAGER_DROPZONE_TEST_ID,
  FILE_PREVIEW_ROOT_TEST_ID,
} from './automation-test-ids';

export const TestIds = {
  ActionItemsNumber: 'action-items-number',
  ActionItemTitle: 'action-item-title',
  ActionItemDescription: 'action-item-description',
  ActionItemAssignee: 'action-item-assignee',
  ActionItemDeadline: 'action-item-deadline',
  /** Use as `` `${TestIds.ActionItemActionPrefix}${type}` `` with `ActionItemType`. */
  ActionItemActionPrefix: 'action-item-action-',
  /** Use as `` `${TestIds.StageTabPrefix}${id}` `` with project tab id. */
  StageTabPrefix: 'stage-',
  ClosedEyeIcon: 'closed-eye-icon',
  OpenEyeIcon: 'open-eye-icon',
  FileUploadButton: 'file-upload-button',
  /**
   * Visible FileManager drop zone (dashed border). The real `<input type="file">`
   * is inside but hidden by react-dropzone; in tests use:
   * `getByTestId(...).locator('input[type="file"]').setInputFiles(...)`.
   */
  FileManagerDropzone: FILE_MANAGER_DROPZONE_TEST_ID,
  ConfirmFilesUploadButton: CONFIRM_FILES_UPLOAD_TEST_ID,
  FilePreview: FILE_PREVIEW_ROOT_TEST_ID,
  DocumentTagSelector: 'document-tag-selector',
  DocumentTypeCombobox: 'document-type-combobox',
  SpendCategoryCombobox: 'spend-category-combobox',
  VendorCombobox: 'vendor-combobox',
  VendorsCategorySelect: 'vendors-category-select',
  VendorPointOfContactPopover: 'vendor-poc-popover',
  VendorPointOfContactPhone: 'vendor-poc-phone',
  VendorPointOfContactEmail: 'vendor-poc-email',
  DocumentFilenameEditor: 'document-filename-editor',
  AddTagButton: 'add-tag-button',
  TeamManagerName: 'team-manager-name',
  TeamPhoneButton: 'team-phone-button',
  TeamEmailLink: 'team-email-link',
  TeamScheduleMeetingLink: 'team-schedule-meeting-link',
  TeamMembersPhoneButton: 'team-members-phone-button',
  TeamMembersEmailLink: 'team-members-email-link',
  TeamMembersScheduleMeetingLink: 'team-members-schedule-meeting-link',
  TeamMembersSection: 'team-members-section',
  TeamMembersContactCard: 'team-members-contact-card',
  TeamMembersRoleSelect: 'team-members-role-select',
  SpendAreaCard: 'spend-area-card',
  HelpFaqItem: 'help-faq-item',
  HelpFaqPreviewButton: 'help-faq-preview-button',
  HelpFaqDownloadLink: 'help-faq-download-link',
  ReportsTab: 'reports-tab',
  ReportsEmbed: 'reports-embed',
  ActionItemTemplateRow: 'action-item-template-row',
  /** Extension Templates — template group card on list / org drawer. */
  ActionItemTemplateGroupCard: 'action-item-template-group-card',
  AllActionItemsScopeFilter: 'all-action-items-scope-filter',
  AllActionItemsGroupFilter: 'all-action-items-group-filter',
  AllActionItemsSearchInput: 'all-action-items-search-input',
  AllActionItemsEmptyState: 'all-action-items-empty-state',
  /** Prefer with `data-organization-id`. */
  AllActionItemsOrganizationSection: 'all-action-items-organization-section',
  /** Prefer with `data-action-item-id` — All Action Items + org action-item list. */
  ActionItemRow: 'action-item-row',
  ActionItemEditButton: 'action-item-edit-button',
  ActionItemCompleteCheckbox: 'action-item-complete-checkbox',
} as const;

export type TestId = (typeof TestIds)[keyof typeof TestIds];
